import { c as _c } from "react/compiler-runtime";
import { MouseEventHandler, RefObject, useState } from "react";
import { X } from "lucide-react";
import { usePromosTheme } from "modules/promos/hooks/usePromosTheme";
import clsx from "classnames";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
interface DonationDialogProps {
  message: string;
  buttonText: string;
  onClose: Function;
  onClick: MouseEventHandler<HTMLButtonElement>;
  creativeRef: RefObject<HTMLDivElement>;
}
export const StickyPopup = t0 => {
  "use memo";

  const $ = _c(21);
  const {
    message,
    buttonText,
    onClose,
    onClick,
    creativeRef
  } = t0;
  const [open, setOpen] = useState(true);
  const {
    backgroundColor
  } = usePromosTheme();
  const t = useTranslations("promos");
  let t1;
  if ($[0] !== onClose) {
    t1 = () => {
      setOpen(false);
      onClose();
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClose = t1;
  if (!open) {
    return null;
  }
  let t2;
  if ($[2] !== backgroundColor) {
    t2 = clsx("fixed inset-x-2 bottom-2 mx-auto max-w-md rounded text-center text-white shadow-lg md:bottom-4", backgroundColor);
    $[2] = backgroundColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== message) {
    t3 = <p className="font-sans-heading px-12 pt-12 pb-6 text-lg leading-snug font-semibold">{message}</p>;
    $[4] = message;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== buttonText || $[7] !== onClick) {
    t4 = <div className="pb-12"><button className="inline-block rounded bg-gray-100 px-5 py-3 font-semibold text-black hover:bg-gray-200" onClick={onClick}>{buttonText}</button></div>;
    $[6] = buttonText;
    $[7] = onClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("button.close");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <X className="size-5" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== handleClose || $[13] !== t5) {
    t7 = <button type="button" className="absolute top-3 right-3" onClick={handleClose} aria-label={t5}>{t6}</button>;
    $[12] = handleClose;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== creativeRef || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t7) {
    t8 = <div className={t2} ref={creativeRef} data-testid="sticky-popup">{t3}{t4}{t7}</div>;
    $[15] = creativeRef;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};